module.exports = __webpack_public_path__ + "static/alvar-blk-f2ce3a8e6f75860faea4aaee87b93c9b.jpeg";